import styled from 'styled-components'

export const PaginaInicial = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding-top: 10px;
  margin: 0 auto;

  .div-btn {
    display: flex;
    flex-direction: column;
  }
`
